<template>
    <form
        id="onboarding-de"
        class="wrapper wrapper-tab wrapper-tab-9"
        role="form"
        method="post"
        @submit.prevent=""
        novalidate
    >
        <header>
            <span class="new-headline-xlg text-centered">Ist es derzeit für Sie ein Problem...</span>
        </header>

        <div class="form-input-wrapper has-gradient">
            <div :class="['form-input-wrapper-scroll', {'scrolled': scrollPosition > 0}]" ref="scrollDiv">
                <div class="radio-list-header" ref="scrollHeader">
                    <span v-for="(item, index) in options" :key="index" v-html="item.label"></span>
                </div>

                <div v-for="radio in radioList" :key="radio.name" class="form-input-radio-list">
                    <div class="form-input-radio-list-inner">
                        <span v-html="radio.label"></span>

                        <div class="radio-list-wrapper form-input-radio form-input-radio--check">
                            <div v-for="(item, index) in options" :key="index" class="radio-wrapper">
                                <input
                                    :id="radio.name + '-' + index"
                                    type="radio"
                                    :name="radio.name"
                                    :value="item.value"
                                    :checked="item.value === radio.value"
                                />
                                <label class="label-static" :for="radio.name + '-' + index" @click="clickOnRadio(radio.name)"></label>
                            </div>
                        </div>
                    </div>

                    <form-input-error
                        v-if="errors && errors[radio.name] && errors[radio.name] !== null"
                        :error="errors[radio.name][0]"
                        :style="'margin-left:' + scrollPosition + 'px'"
                    ></form-input-error>
                </div>
            </div>

            <v-button label="Weiter" size="lg" type="submit" @onClick="onClickButton()" full-width></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            uuid: {
                type: String,
                required: true
            },
            data: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                scrollPosition: null,
                errors: {},
                isDisabled: true,
                options: [
                    { label: 'kein Problem', value: 0 },
                    { label: 'eher geringes Problem', value: 1 },
                    { label: 'mittleres Problem', value: 2 },
                    { label: 'ehergrößeres Problem', value: 3 },
                    { label: 'großes Problem', value: 4 }
                ],
                radioList: [
                    {
                        label: '... dass Sie keine eindeutigen und klaren Ziele für Ihre Diabetes&shy;behandlung haben?',
                        name: 'problem_1',
                        value: (this.data && parseInt(this.data.problem_1)) ?? null
                    },
                    {
                        label: '... dass Sie sich im Hinblick auf ihre Diabetes&shy;behandlung entmutigt fühlen?',
                        name: 'problem_2',
                        value: (this.data && parseInt(this.data.problem_2)) ?? null
                    },
                    {
                        label: '... dass Sie der Gedanke, mit dem Diabetes leben zu müssen, ängstigt?',
                        name: 'problem_3',
                        value: (this.data && parseInt(this.data.problem_3)) ?? null
                    },
                    {
                        label: '... dass es im Zusammenhang mit Ihrem Diabetes unangenehme soziale Situationen gibt (z.B. wenn Ihnen jemand sagt, was Sie essen sollen)?',
                        name: 'problem_4',
                        value: (this.data && parseInt(this.data.problem_4)) ?? null
                    },
                    {
                        label: '... dass Sie sich im Hinblick auf Nahrungsmittel und Mahlzeiten eingeschränkt fühlen?',
                        name: 'problem_5',
                        value: (this.data && parseInt(this.data.problem_5)) ?? null
                    },
                    {
                        label: '... dass Sie sich beim Gedanken, mit dem Diabetes leben zu müssen, depressiv fühlen?',
                        name: 'problem_6',
                        value: (this.data && parseInt(this.data.problem_6)) ?? null
                    },
                    {
                        label: '... dass Sie sich unsicher sind, inwieweit Ihre Stimmungen und Gefühle mit dem Diabetes zusammen&shy;hängen?',
                        name: 'problem_7',
                        value: (this.data && parseInt(this.data.problem_7)) ?? null
                    },
                    {
                        label: '... dass Sie sich durch Ihre Diabetes&shy;behandlung überfordert fühlen?',
                        name: 'problem_8',
                        value: (this.data && parseInt(this.data.problem_8)) ?? null
                    },
                    {   label: '... dass Sie sich Sorgen über Unterzuckerungen machen?', 
                        name: 'problem_9',
                        value: (this.data && parseInt(this.data.problem_9)) ?? null
                    },
                    {
                        label: '... dass Sie sich bei dem Gedanken, mit dem Diabetes leben zu müssen, ärgerlich fühlen?',
                        name: 'problem_10',
                        value: (this.data && parseInt(this.data.problem_10)) ?? null
                    },
                    {
                        label: '... dass Sie sich ständig gedanklich mit Essen oder mit Nahrungsmitteln beschäftigen?',
                        name: 'problem_11',
                        value: (this.data && parseInt(this.data.problem_11)) ?? null
                    },
                    {
                        label: '... dass Sie sich Sorgen über die Zukunft und über mögliche ernste Folgeer&shy;krankungen machen?',
                        name: 'problem_12',
                        value: (this.data && parseInt(this.data.problem_12)) ?? null
                    },
                    {
                        label: '... dass Sie sich schuldig oder ängstlich fühlen, wenn Sie Ihre Diabetes&shy;behandlung vernachlässigen?',
                        name: 'problem_13',
                        value: (this.data && parseInt(this.data.problem_13)) ?? null
                    },
                    { 
                        label: '... dass Sie Ihren Diabetes nicht akzeptieren können?', 
                        name: 'problem_14',
                        value: (this.data && parseInt(this.data.problem_14)) ?? null
                    },
                    { 
                        label: '... dass Sie mit Ihrem behandelnden Arzt unzufrieden sind?', 
                        name: 'problem_15',
                        value: (this.data && parseInt(this.data.problem_15)) ?? null
                    },
                    {
                        label: '... dass Sie das Gefühl haben, dass der Diabetes Ihnen täglich zu viel geistige/körperliche Kraft raubt?',
                        name: 'problem_16',
                        value: (this.data && parseInt(this.data.problem_16)) ?? null
                    },
                    { 
                        label: '... dass Sie sich mit Ihrem Diabetes allein gelassen fühlen?', 
                        name: 'problem_17',
                        value: (this.data && parseInt(this.data.problem_17)) ?? null
                    },
                    {
                        label: '... dass Sie sich von Ihren Freunden und Ihrer Familie bei der Diabetes&shy;behandlung nicht genügend unterstützt fühlen?',
                        name: 'problem_18',
                        value: (this.data && parseInt(this.data.problem_18)) ?? null
                    },
                    {
                        label: '... dass Sie Schwierigkeiten bei der Bewältigung von Folgeer&shy;krankungen haben?',
                        name: 'problem_19',
                        value: (this.data && parseInt(this.data.problem_19)) ?? null
                    },
                    {
                        label: '... dass Sie sich durch die ständigen Anforderungen der Diabetes&shy;behandlung "ausgebrannt" fühlen?',
                        name: 'problem_20',
                        value: (this.data && parseInt(this.data.problem_20)) ?? null
                    }
                ]
            }
        },

        mounted() {
            var that = this
            const scroll = this.$refs.scrollDiv
            const scrollHeader = this.$refs.scrollHeader
            var position = scrollHeader.getBoundingClientRect()

            scroll.addEventListener(
                'scroll',
                () => {
                    this.scrollPosition = scroll.scrollLeft
                },
                false
            )

            window.addEventListener('scroll', () => {
                var scrolled = document.documentElement.scrollTop || document.body.scrollTop

                if(scrolled > position.top - scrollHeader.offsetHeight) {
                    scrollHeader.style.top = scrolled - position.top + document.querySelector('.site-header').offsetHeight + 8 + "px"
                    scrollHeader.style.background = '#f8f5ff'
                } else {
                    scrollHeader.style.top = "auto"
                    scrollHeader.style.background = 'none'
                }
            })

            setTimeout(() => {
                document.querySelector('.progress-back').addEventListener('click', function(e) {
                    that.saveData();
                }); 
            }, 50);
        },

        computed: {},

        methods: {
            clickOnRadio(name) {
                if (this.errors[name]) {
                    this.errors[name] = null
                    this.$forceUpdate()
                }
            },
            onClickButton() {
                this.validate()

                if (!this.isDisabled) {
                    this.submit()
                } else {
                    Vuemit.fire('Button--sending-failed', true)
                    this.scrollToError()
                }
            },
            validate() {
                var that = this

                for (let radio of this.radioList) {
                    var radioButtonGroup = document.getElementsByName(radio.name)

                    var checkedRadio = Array.from(radioButtonGroup).find((radio) => radio.checked)

                    if (checkedRadio === undefined) {
                        that.errors[radio.name] = ['Sie müssen mindestens eine Option auswählen.']
                        this.$forceUpdate()
                    }
                }

                for (let radio of this.radioList) {
                    var radioButtonGroup = document.getElementsByName(radio.name)

                    var checkedRadio = Array.from(radioButtonGroup).find((radio) => radio.checked)

                    if (checkedRadio !== undefined) {
                        that.isDisabled = false
                        that.errors[radio.name] = null
                        this.$forceUpdate()
                    } else {
                        that.isDisabled = true
                        break
                    }
                }
            },
            submit() {
                var data = {
                    uuid: this.uuid,
                    answers: {
                        last_tab: {
                            key: 'last_tab',
                            value: this.type === 'first' ? '10' : '8'
                        }
                    }
                }

                this.radioList.forEach((radio, index) => {
                    var radioButtonGroup = document.getElementsByName(radio.name)

                    var checkedRadio = Array.from(radioButtonGroup).find((radio) => radio.checked)

                    data.answers[radio.name] = { key: radio.name, value: checkedRadio.value.toString() }
                })

                axios
                    .post('/rwe-study', data, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.$emit('clicked', data.answers, true)
                    })
                    .catch((e) => {
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                        this.scrollToError()
                    })
            },
            async scrollToError() {
                await this.$nextTick()

                var firstError = document.querySelector('.input-error')

                $('html, body').animate(
                    {
                        scrollTop: $(firstError.previousElementSibling).offset().top - 180
                    },
                    800
                )
            },
            saveData() {
                var data = {
                    answers: {}
                }

                this.radioList.forEach((radio, index) => {
                    var radioButtonGroup = document.getElementsByName(radio.name)

                    var checkedRadio = Array.from(radioButtonGroup).find((radio) => radio.checked)

                    data.answers[radio.name] = { key: radio.name, value: checkedRadio ? checkedRadio.value.toString() : null }
                })

                this.$emit('clicked', data.answers, false)
            }
        }
    }
</script>
